import { from } from "rxjs";
import { selectOutskirtBuildingUpgradeMissingRequirements } from "../../../../selectors/selectOutskirtBuildingUpgradeInfo";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { IdMissingResourceTypes } from "../../../not-enough-resource/IdMissingResourceTypes";
import { actionOngoingPurchaseStandardSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
export var pathOutskirtBuildingUpgradeNotEnoughResources = function (action, state$) {
    var state = state$.value;
    var outskirtBuildingId = action.building.balancing.id;
    var missingResources = selectOutskirtBuildingUpgradeMissingRequirements(state, outskirtBuildingId);
    return from([
        actionOngoingPurchaseStandardSelect([
            {
                missingResources: missingResources,
                missingType: IdMissingResourceTypes.Resources,
            },
        ]),
        actionModalOpen(IdModal.NotEnoughResource),
    ]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/outskirts/paths/pathOutskirtBuildingUpgradeNotEnoughResources.ts
// module id = 1923
// module chunks = 3